import React, { useState } from "react";
import { connect } from "react-redux";
/* import { deepClone } from "../../../../../helpers/objectHelper";
import { textAreaHandler } from "./TextArea.handler";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { HtmlWrapper } from "../../components/HtmlWrapper";
import { toKebabCase } from "../../../../../helpers/cssHelper";
import TextWrapper from "../../components/TextWrapper"; */

const CalendarInvitation = (props) => {
 /*  const { content } = props.element; */
  const { selectedElement, element } = props;

  /*  const textOnChange = (text) => {
        const { element, dispatch, template } = props;
        const updatedElement = deepClone(element);
        try {
            updatedElement.style.elementProps.text = text;
        } catch (error) {
            console.log('ERR: COULD NOT SET TEXT')
        }
        updatedElement.content = textAreaHandler.elementEditor(updatedElement.style, template.template ? template.template.content : null, null);
        props.dispatch(emailActions.updateEmailElement(updatedElement, null, true, props.inherit));
    } */
  return (
    <React.Fragment>
      <tr>
        <td style={element.style.wrapper}>
          <table role="presentation" cellSpacing="0" cellPadding="0" border="0" width="100%">
            <tbody>
              <tr>
                <td style={element.style.styleProps} dangerouslySetInnerHTML={{__html: `
                 <a href="${element.style.elementProps.link}" download=${element.style.elementProps.text}> ${element.style.elementProps.text}</a>
                
                `}}>
                  {/*     <TextWrapper
                                        element={element}
                                        contentId={element.id}
                                        linkColor={props.template.template && props.template.template.content.a.color}
                                        elementStyle={element.style.styleProps}
                                        text={element.style.elementProps.text}
                                        textOnChange={textOnChange}
                                    /> */}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    selectedElement: state.email.selectedElement,
    inherit: state.email.inherit,
    template: state.template,
  };
}

export default connect(mapStateToProps)(CalendarInvitation);
